import { MoreVertOutlined } from "@mui/icons-material";
import { Box, Card, IconButton, Typography } from "@mui/material";
import React from "react";
import VehiclesStyles from "../../Vehicles/VehiclesStyles";
import { IPolicyVehicle } from "../../../../../../models/user/policyDetails/PolicyDetails";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DriversStyles from "../../Drivers/DriversStyles";
import { isFeatureAvailable } from "../../../../../../utils/Utility";
import { renderAddress } from "../Vehicles";
import { useAppSelector } from "../../../../../../store/hooks";
import { RootState } from "../../../../../../store/store";

interface IProps {
  vehicles: IPolicyVehicle[];
  handleMoreClick?: (event: any, vehicle: any) => void;
  displayMoreOptions: boolean;
}
const VehiclesMobileView: React.FC<IProps> = ({
  vehicles,
  handleMoreClick,
}) => {
  const { t } = useTranslation();

  const { features } = useAppSelector((state: RootState) => state.features);

  return (
    <Box 
      sx={{ display: "grid", gap: "20px" }}
      id="vehicles_mobile_container"
      data-test-id="vehicles_mobile_container"
      aria-label="Vehicles mobile view container"
    >
      {vehicles?.length > 0 ? (
        vehicles?.map((vehicle: IPolicyVehicle, index: number) => (
          <Card 
            key={`veh-${index}`} 
            sx={VehiclesStyles.mobileCard}
            id={`vehicles_mobile_card_${index}`}
            data-test-id={`vehicles_mobile_card_${index}`}
            aria-label={`Vehicle ${index + 1} details`}
          >
            <Typography
              sx={{
                ...VehiclesStyles.year,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "wrap",
              }}
              id={`vehicles_mobile_details_${index}`}
              data-test-id={`vehicles_mobile_details_${index}`}
              aria-label={`Vehicle details: ${vehicle.manufactureYr}-${vehicle.make}-${vehicle.model}`}
            >
              {vehicle.manufactureYr}-{vehicle.make}-{vehicle.model}
            </Typography>
            <Typography 
              sx={VehiclesStyles.vin}
              id={`vehicles_mobile_vin_${index}`}
              data-test-id={`vehicles_mobile_vin_${index}`}
              aria-label={`Vehicle VIN: ${vehicle.vin}`}
            >
              {vehicle.vin}
            </Typography>
            <Box 
              sx={VehiclesStyles.type}
              id={`vehicles_mobile_garage_${index}`}
              data-test-id={`vehicles_mobile_garage_${index}`}
              aria-label="Vehicle garage location"
            >
              {t("Garage Location")}:&nbsp;
              <Typography
                sx={{
                  ...VehiclesStyles.vehicleType,
                  fontWeight: "unset",
                  color: "#000000",
                }}
                id={`vehicles_mobile_garage_address_${index}`}
                data-test-id={`vehicles_mobile_garage_address_${index}`}
                aria-label={`Garage address: ${vehicle.address && renderAddress(vehicle.address)}`}
              >
                {vehicle.address && renderAddress(vehicle.address)}
              </Typography>
            </Box>
            {isFeatureAvailable({
              featureCodes: [
                "lob_pa_policies_delete_vehicle",
                "lob_pa_policies_update_coverages",
              ],
              features,
            }) ? (
              <IconButton
                sx={{ position: "absolute", right: "0px" }}
                onClick={(event) =>
                  handleMoreClick && handleMoreClick(event, vehicle)
                }
                id={`vehicles_mobile_more_${index}`}
                data-test-id={`vehicles_mobile_more_${index}`}
                aria-label="More vehicle options"
              >
                <MoreVertOutlined />
              </IconButton>
            ) : (
              <></>
            )}
          </Card>
        ))
      ) : (
        <Card 
          sx={DriversStyles.noDriversCard}
          id="vehicles_mobile_no_vehicles"
          data-test-id="vehicles_mobile_no_vehicles"
          aria-label="No vehicles found"
        >
          <Typography 
            sx={DriversStyles.noDriversText}
            id="vehicles_mobile_no_vehicles_text"
            data-test-id="vehicles_mobile_no_vehicles_text"
            aria-label="No vehicles found message"
          >
            {t("No Vehicles Found")}
          </Typography>
        </Card>
      )}
    </Box>
  );
};

export default VehiclesMobileView;
